<script setup lang="ts">
  defineOptions({
    name: 'NotificationWeb',
  })

  import { computed } from 'vue'

  import { useGlobal } from '@common/core-layer/composables/useGlobal'

  import NotificationWebMobile from './NotificationWeb.mobile.vue'
  import NotificationWebDesktop from './NotificationWeb.web.vue'
  import { notificationWebProps } from './notificationWeb.shared'

  const props = defineProps(notificationWebProps)

  defineEmits<{
    (e: 'update:notificationListIsOpen'): void
  }>()

  const { isMobileOrTablet } = useGlobal()

  const currentComponent = computed(() => (isMobileOrTablet() ? NotificationWebMobile : NotificationWebDesktop))
</script>

<template>
  <component :is="currentComponent" v-bind="props" @update:notificationListIsOpen="$emit('update:notificationListIsOpen')" />
</template>
